'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var DynamicHeader = require('@narvar/nth-bundle-dynamic-header');
var NarvarFooter = require('@narvar/nth-bundle-narvar-footer');
var index = require('../../components/CsrSignInForm/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var DynamicHeader__default = /*#__PURE__*/_interopDefaultLegacy(DynamicHeader);
var NarvarFooter__default = /*#__PURE__*/_interopDefaultLegacy(NarvarFooter);

const PageWrapper = styled__default["default"].div.withConfig({
  componentId: "sc-vcdx1d-0"
})(["overflow-x:hidden;"]);
const DesktopHeightWrapper = styled__default["default"].div.withConfig({
  componentId: "sc-vcdx1d-1"
})(["@media screen and (min-width:768px){min-height:calc(100vh - 250px);}"]);
const FooterPadding = styled__default["default"].div.withConfig({
  componentId: "sc-vcdx1d-2"
})(["padding-top:2rem;width:100%;@media screen and (max-width:768px){", "}> footer > div{padding:1rem 1.5rem;}"], _ref => {
  let {
    sticky
  } = _ref;
  return sticky ? {
    position: 'fixed',
    bottom: 0
  } : {};
});
const CsrSignInWizard = () => {
  return /*#__PURE__*/React__default["default"].createElement(PageWrapper, null, /*#__PURE__*/React__default["default"].createElement(DynamicHeader__default["default"], {
    featureName: "narvarHeader"
  }), /*#__PURE__*/React__default["default"].createElement(DesktopHeightWrapper, null, /*#__PURE__*/React__default["default"].createElement(index["default"], null)), /*#__PURE__*/React__default["default"].createElement(FooterPadding, {
    sticky: true
  }, /*#__PURE__*/React__default["default"].createElement(NarvarFooter__default["default"], {
    featureName: "narvarFooter"
  })));
};

exports["default"] = CsrSignInWizard;
